import { Component, ContentChild, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { ISharedSidebarItem } from './shared-sidebar-list/shared-sidebar.interface';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { flattenDeep, valuesIn } from 'lodash-es';
import { INavBarAccessibilityContent, ITranslateNavBarConfig, NavBarType } from './nav-bar.interface';
import { TLang } from '../../../family-connectors-portal/src/app/constants/supported-languages';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NavBarComponent implements OnInit {
  public selectedSidebarItem: string;
  private activeUrl: string | undefined;

  @Input() navAriaLabels: INavBarAccessibilityContent;
  @Input() navConfigs: { [key:string]: ISharedSidebarItem[] } = { main: [], small: [] };
  @Input() navType: NavBarType = NavBarType.SIDE_NAV;
  @Input() translateConfig: ITranslateNavBarConfig;
  @Input() navLogoType: string;
  @Output() clickedBurgerMenu = new EventEmitter<{ action: 'closeTopNavMenu' | 'openTopNavMenu' }>();
  @Output() switchLanguage = new EventEmitter<string>();

  @ContentChild('navExtras') navExtras: TemplateRef<any>;

  constructor (
    private auth: AuthService,
    private router: Router,
  ) {}

  ngOnInit (): void {
    this.setNavConfigs();
  }

  // TODO - further discuss if we could generalize and use AuthService here
  public logout (): void {
    this.auth.logout({
      logoutParams: {
        federated: true,
        returnTo: window.location.origin,
      },
    });
  }

  public onKeyUp (e: KeyboardEvent): void {
    if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
      this.navigateToHomepage();
    }
  }

  public navigateToHomepage (): void {
    this.router.navigate(['/']);
  }

  public onClickBurgerMenu ({ action }: { action: 'closeTopNavMenu' | 'openTopNavMenu'}): void {
    this.clickedBurgerMenu.emit({ action });
  }

  public onNavItemSelect (navConfigs: { [key:string]: ISharedSidebarItem[] }, { selectedItemKey, activeUrl }: { selectedItemKey?: string, activeUrl?: string }): void {
    const navItem = this.updateSelectedItem(navConfigs, { selectedItemKey, activeUrl });
    const keyToCompare = navItem?.key.toLowerCase();
    if (keyToCompare === 'log out') {
      this.logout();
    }
  }

  public updateSelectedItem (navConfigs: { [key:string]: ISharedSidebarItem[] }, { selectedItemKey, activeUrl }: { selectedItemKey?: string, activeUrl?: string }): ISharedSidebarItem | undefined | null {
    const all = flattenDeep(valuesIn(navConfigs));
    const navItem = all.find(({ key, url }) => key === selectedItemKey || activeUrl?.includes(`${this.getActiveUrl(url)}`));
    if (navItem) {
      this.selectedSidebarItem = navItem.key;
      return navItem;
    }
  }

  private getActiveUrl (url: string | undefined): string | undefined {
    if (!url) return;
    const [urlWithoutParams] = url.split('?');
    return urlWithoutParams;
  }

  private setNavConfigs () {
    this.activeUrl = this.getActiveUrl(this.router.routerState.snapshot.url);
    this.onNavItemSelect(this.navConfigs, { activeUrl: this.activeUrl });
  }

  public onSwitchLanguage (dropDownOption: { key: TLang; human: string }) {
    if (this.translateConfig.selectedLangName !== dropDownOption.human) {
      const lang = dropDownOption.key;
      this.switchLanguage.emit(lang);
    }
  }
}
